import { ThermometerAlertIcon } from './ThermometerAlertIcon';

/**
 * author: Michael Richins
 * id DB3D5088-E7A7-47AD-87E3-43D5B41BF0C2
 * name thermometer-alert
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-alert.svg
 * tags
 * - Home Automation 
 * - Weather 
 * - Alert / Error 
 */
export const TemperatureAlertIcon = ThermometerAlertIcon;
export default TemperatureAlertIcon